import { useEffect, useState } from 'react';

export const WithTimeout = (WrappedComponent, milliseconds) => {
  const CMP = (props) => {
    const [toggle, setToggle] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => setToggle(false), milliseconds);
      return () => {
        clearTimeout(timer);
      };
    }, [toggle]);

    return <WrappedComponent {...props} timer={{ toggle, setToggle }} />;
  };

  return (props) => {
    return <CMP {...props} />;
  };
};
